import { render, staticRenderFns } from "./BadgeAndAwards.vue?vue&type=template&id=0416e2b2&"
import script from "./BadgeAndAwards.vue?vue&type=script&lang=js&"
export * from "./BadgeAndAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports